// La empresa con que se trabaja (DA-16). Mismo comportamiento que el CRM
// (src/lib/empresa.js): quien es usuario de varias escoge una; se recuerda
// por pestaña (sessionStorage) y como preferida (localStorage). Es solo una
// elección: el servidor la acepta si ese correo tiene acceso.
const LLAVE = 'nara_empresa';
let lista = null;   // las empresas que devolvió /auth/empresas en esta página

const leer = (almacen) => { try { return almacen.getItem(LLAVE) || null; } catch { return null; } };

export function empresaActual() {
  return leer(sessionStorage) || leer(localStorage);
}

export function fijarEmpresa(identificador) {
  try { sessionStorage.setItem(LLAVE, identificador); } catch { /* sin almacenamiento */ }
  try { localStorage.setItem(LLAVE, identificador); } catch { /* sin almacenamiento */ }
}

export function olvidarEmpresa() {
  try { sessionStorage.removeItem(LLAVE); } catch { /* sin almacenamiento */ }
  try { localStorage.removeItem(LLAVE); } catch { /* sin almacenamiento */ }
}

export const guardarLista = (l) => { lista = l; };
export const listaEmpresas = () => lista;

/** El hub abre `erp.nara.chat/?empresa=<id>`: se toma y se quita de la dirección. */
export function tomarEmpresaDeLaDireccion() {
  const u = new URL(window.location.href);
  const e = u.searchParams.get('empresa');
  if (!e) return;
  fijarEmpresa(e);
  u.searchParams.delete('empresa');
  window.history.replaceState(null, '', u.pathname + u.search + u.hash);
}

/** Para las descargas que se abren en otra pestaña (no llevan cabeceras). */
export function conEmpresa(url) {
  const e = empresaActual();
  if (!e) return url;
  return `${url}${url.includes('?') ? '&' : '?'}empresa=${encodeURIComponent(e)}`;
}

/** Cambiar de empresa recarga todo. Lo guardado de la otra (usuario, rol,
 *  sede, período) no sirve aquí. */
export function cambiarDeEmpresa(identificador) {
  ['user_id', 'user_email', 'user_nombre', 'user_rol', 'nara_erp_sede_activa', 'nara_erp_periodo_activo']
    .forEach((k) => { try { localStorage.removeItem(k); } catch { /* sin almacenamiento */ } });
  fijarEmpresa(identificador);
  window.location.assign('/');
}
